import { render, staticRenderFns } from "./ImagePicker.vue?vue&type=template&id=c55e8f80&scoped=true"
import script from "./ImagePicker.vue?vue&type=script&lang=js"
export * from "./ImagePicker.vue?vue&type=script&lang=js"
import style0 from "./ImagePicker.vue?vue&type=style&index=0&id=c55e8f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55e8f80",
  null
  
)

export default component.exports